import type { BasketApiItem, CartProp, GetCartProductsItem } from "~/types/cart";

function normalizeCartProps(cartProps?: CartProp[]): CartProp[] {
  return Array.isArray(cartProps) ? cartProps : [];
}

export function toGetCartProductsItem(
  basketItem: BasketApiItem,
): GetCartProductsItem {
  return {
    productId: basketItem.PRODUCT_ID,
    cartProps: normalizeCartProps(basketItem.CART_PROPS),
  };
}
